import React from 'react';

const Experience = () => {
    return (
        <div>
           <div className="container mt-5 mb-4">
        <div className="text-center w-70 m-auto">
          <h2 className="font" style={{ color: "crimson" }}>
           Experience
          </h2>
        </div>
      </div> 
      <div>
        <p className="text-center w-90 m-auto">I have 4.5 years of Experience in Mern Stack Development, and worked with Technomax System Pvt Ltd </p>
      </div>
        </div>
    );
};

export default Experience;